<template>
  <div id="contenedor-editar-usuario-contratista">
    <v-form ref="formEditarUsuarioContratista">
      <v-row>
        <v-col cols="12">
          <CustomTextField v-model="usuario.correoElectronico" label="Correo"> </CustomTextField>
        </v-col>
        <v-col>
          <CustomTextField v-model="usuario.password" label="Password" type="password">
          </CustomTextField>
        </v-col>
        <v-col>
          <CustomTextField v-model="usuario.rePassword" label="Re-Password" type="password">
          </CustomTextField>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import USUARIOS from '@/graphql/querys/administracion/catalogos/usuarios/usuarios.gql';
import ACTUALIZAR_USUARIO from '@/graphql/mutations/administracion/catalogos/usuarios/actualizarUsuario.gql';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';

export default {
  name: 'EditarUsuarioContratista',
  props: {
    usuarioContratistaEditar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
  },
  data() {
    return {
      usuario: {
        idFuncionario: null,
        correoElectronico: this.usuarioContratistaEditar.correoElectronico,
        avatarPublicKey: this.usuarioContratistaEditar.avatarPublicKey,
        password: '',
        rePassword: '',
        roles: ['CONTRATISTA:SUPERVISION'],
        scopes: ['Supervisión:ver', 'Supervisión:crear', 'Supervisión:editar'],
      },
    };
  },
  methods: {
    async actualizar() {
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_USUARIO,
          variables: {
            id: this.usuarioContratistaEditar.id,
            usuario: this.usuario,
          },
          update: (cache, { data: { actualizarUsuario } }) => {
            const data = cache.readQuery({ query: USUARIOS });
            const { usuarios } = data;
            const index = usuarios.findIndex((u) => u.id === actualizarUsuario.id);
            if (index !== -1) {
              usuarios.splice(index, 1, actualizarUsuario);
            }

            cache.writeQuery({ query: USUARIOS, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.cerrar();
    },
    cerrar() {
      this.$refs.formEditarUsuarioContratista.reset();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss"></style>
